if (!customElements.get('reviews-carousel')) {
  class ReviewsCarousel extends HTMLElement {
    swiper = null;
    swiperRetry = null;
    videoObserver = null;

    connectedCallback() {
      this.createSwiper();
      this.observeVideos();
    }

    disconnectedCallback() {
      clearTimeout(this.swiperRetry);
      this.destroySwiper();
      this.disconnectVideoObserver();
    }

    handleVideoIntersection(entries) {
      for (const entry of entries) {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.readyState === 0) video.load();
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    }

    observeVideos() {
      const videos = this.querySelectorAll('video');
      if (!videos.length) return;

      this.videoObserver = new IntersectionObserver((entries) => this.handleVideoIntersection(entries),
        { threshold: 0.5 }
      );

      for (const video of videos) {
        this.videoObserver.observe(video);
      }
    }

    disconnectVideoObserver() {
      if (!this.videoObserver) return;
      this.videoObserver.disconnect();
      this.videoObserver = null;
      for (const video of this.querySelectorAll('video')) {
        video.pause();
      }
    }

    createSwiper() {
      if (this.swiper) return;

      if (typeof Swiper === 'undefined') {
        this.swiperRetry = setTimeout(() => this.createSwiper(), 100);
        return;
      }

      const container = this.querySelector('.swiper');
      if (!container) return;

      const items = parseFloat(this.dataset.items) || 1;
      const desktopItems = parseFloat(this.dataset.itemsDesktop) || items;
      const tabletItems = desktopItems / 2 + 1;
      const gap = parseFloat(this.dataset.gap) || 16;
      const nav = this.dataset.nav === 'true';
      const wrap = this.closest('.lp-carousel__slider-wrap');
      const isDesktopCarousel = Boolean(this.closest('.lp-desktop-only'));

      const config = {
        slidesPerView: items,
        spaceBetween: gap,
        slidesOffsetAfter: isDesktopCarousel ? 0 : 20,
        navigation: nav && wrap ? {
          nextEl: wrap.querySelector('.lp-nav-btn--next'),
          prevEl: wrap.querySelector('.lp-nav-btn--prev'),
        } : false,
        breakpoints: {
          768: {
            slidesPerView: tabletItems,
            spaceBetween: gap,
          },
          1290: {
            slidesPerView: isDesktopCarousel ? desktopItems : items,
            spaceBetween: gap,
          },
        },
      };

      this.swiper = new Swiper(container, config);
    }

    destroySwiper() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define('reviews-carousel', ReviewsCarousel);
}